// Mock data for IT Services website

export const services = [
  {
    id: 1,
    title: "Server Rack Installation",
    description: "Professional installation and configuration of server racks with optimal cable management and cooling solutions.",
    features: ["Rack mounting", "Cable management", "Cooling optimization", "Power distribution"],
    icon: "server"
  },
  {
    id: 2,
    title: "Enterprise Networking Solutions",
    description: "Complete enterprise network infrastructure design and deployment for seamless connectivity across your organization.",
    features: ["Enterprise LAN/WAN", "Advanced routing", "Network security", "Scalable infrastructure"],
    icon: "network"
  },
  {
    id: 3,
    title: "IoT & Automation",
    description: "Smart office solutions with IoT devices and automation systems for enhanced efficiency.",
    features: ["Smart sensors", "Automation systems", "Device integration", "Remote monitoring"],
    icon: "cpu"
  },
  {
    id: 4,
    title: "Corporate Internet Services",
    description: "High-speed SME internet and dedicated leased line solutions for uninterrupted business operations.",
    features: ["SME internet plans", "Leased line connectivity", "24/7 uptime", "Dedicated bandwidth"],
    icon: "globe"
  },
  {
    id: 5,
    title: "Desktop AMC Services",
    description: "Annual Maintenance Contract for comprehensive desktop and hardware support with guaranteed response times.",
    features: ["Yearly maintenance plans", "Hardware troubleshooting", "Software support", "Priority service"],
    icon: "wrench"
  },
  {
    id: 6,
    title: "Point-to-Point Wireless Broadband",
    description: "High-speed wireless connectivity solutions for locations where wired connections are not feasible.",
    features: ["Long-range wireless links", "High bandwidth delivery", "Weather-resistant setup", "Minimal latency"],
    icon: "radio"
  },
  {
    id: 7,
    title: "Drone & Robotics Technology & AI Solutions",
    description: "Cutting-edge drone technology and robotics powered by AI for automation, surveillance, and innovative applications.",
    features: ["Drone deployment", "AI-powered robotics", "Automated solutions", "Smart analytics"],
    icon: "bot"
  },
  {
    id: 8,
    title: "Web/Software Development",
    description: "Custom web and software development solutions tailored to your business needs with modern technologies.",
    features: ["Custom web apps", "Software solutions", "Mobile applications", "Cloud integration"],
    icon: "code"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Prakash Somani",
    company: "Paprika Lead Generation Pvt Ltd",
    role: "CEO",
    content: "Outstanding service! Their team completed our server rack installation ahead of schedule with exceptional attention to detail.",
    rating: 5
  },
  {
    id: 2,
    name: "Amit Oberoi",
    company: "GAIL (India) Limited",
    role: "Manager",
    content: "The network setup was flawless. Our office connectivity has never been better. Highly recommend their services.",
    rating: 5
  },
  {
    id: 3,
    name: "Rajeev Chada",
    company: "NTPC Limited",
    role: "Operational Manager",
    content: "Their IoT automation solutions transformed our workspace. Professional, efficient, and great support.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is included in server rack installation?",
    answer: "Our server rack installation includes complete rack mounting, professional cable management, cooling system setup, power distribution configuration, and thorough testing to ensure optimal performance."
  },
  {
    id: 2,
    question: "How long does a typical network setup take?",
    answer: "Network setup timeline varies based on office size and complexity. Small offices (10-20 users) typically take 2-3 days, while larger deployments may require 1-2 weeks. We provide detailed timelines during consultation."
  },
  {
    id: 3,
    question: "Do you provide ongoing support and maintenance?",
    answer: "Yes, we offer comprehensive support packages including 24/7 monitoring, regular maintenance, emergency response, and system upgrades to ensure your infrastructure runs smoothly."
  },
  {
    id: 4,
    question: "What's the difference between SME internet and leased lines?",
    answer: "SME internet offers shared high-speed connectivity ideal for small to medium businesses. Leased lines provide dedicated bandwidth with guaranteed speeds and SLAs, perfect for enterprises requiring consistent, uninterrupted connectivity."
  },
  {
    id: 5,
    question: "Can you integrate IoT devices with existing systems?",
    answer: "Absolutely! Our IoT solutions are designed to integrate seamlessly with your existing infrastructure. We assess your current setup and recommend compatible devices and automation systems."
  }
];

export const stats = [
  { label: "Projects Completed", value: "500+", icon: "check-circle" },
  { label: "Happy Clients", value: "200+", icon: "users" },
  { label: "Years Experience", value: "15+", icon: "award" },
  { label: "Support Uptime", value: "99.9%", icon: "activity" }
];

export const contactInfo = {
  email: "stark360t@gmail.com",
  phone: "+91 7783938347",
  address: "India"
};

export const companyInfo = {
  name: "Tech360 Technologies",
  tagline: "Advanced Technology & Automation Solutions",
  ceo: {
    name: "Er. Prashant Kumar",
    title: "Owner & CEO",
    photo: "https://customer-assets.emergentagent.com/job_corporate-connect-18/artifacts/att4qvtn_1000030012.jpg"
  },
  logo: "https://customer-assets.emergentagent.com/job_corporate-connect-18/artifacts/xw1b7hzb_1000082141.png"
};

export const pricingPlans = [
  {
    id: 1,
    name: "Starter",
    price: "₹499",
    period: "Per month",
    description: "Basic IT support for small teams.",
    features: [
      "Email support",
      "Network setup",
      "Security checks"
    ],
    buttonText: "Start free",
    popular: false
  },
  {
    id: 2,
    name: "Basic",
    price: "₹1499",
    period: "Per month",
    description: "IT help for growing businesses.",
    features: [
      "24/7 helpdesk",
      "Remote support",
      "Cloud backup"
    ],
    buttonText: "Choose plan",
    popular: true
  },
  {
    id: 3,
    name: "Team",
    price: "₹2999",
    period: "Per month",
    description: "Advanced support for teams.",
    features: [
      "Priority response",
      "On-site visits",
      "Automation tools",
      "Network tuning"
    ],
    buttonText: "Select plan",
    popular: false
  },
  {
    id: 4,
    name: "Business",
    price: "₹4999",
    period: "Per month",
    description: "Full IT and internet solutions.",
    features: [
      "Account manager",
      "Enhanced security",
      "Custom integrations",
      "Proactive maintenance",
      "Unlimited support"
    ],
    buttonText: "Get started",
    popular: false
  }
];

export const smePlans = [
  {
    id: 2,
    name: "SME Line 10 Mbps",
    speed: "10 Mbps",
    price: "₹1,296.82",
    validity: "30 Days",
    features: ["Unlimited Data", "24/7 Support", "High-Speed Connection"],
    popular: true
  },
  {
    id: 3,
    name: "SME Line 20 Mbps",
    speed: "20 Mbps",
    price: "₹2,004.82",
    validity: "30 Days",
    features: ["Unlimited Data", "24/7 Support", "High-Speed Connection"]
  },
  {
    id: 4,
    name: "SME Line 30 Mbps",
    speed: "30 Mbps",
    price: "₹3,066.82",
    validity: "30 Days",
    features: ["Unlimited Data", "24/7 Support", "High-Speed Connection"]
  },
  {
    id: 5,
    name: "SME Line 50 Mbps",
    speed: "50 Mbps",
    price: "₹4,246.82",
    validity: "30 Days",
    features: ["Unlimited Data", "24/7 Support", "High-Speed Connection"]
  },
  {
    id: 7,
    name: "SME Line 100 Mbps",
    speed: "100 Mbps",
    price: "₹7,432.82",
    validity: "30 Days",
    features: ["Unlimited Data", "24/7 Support", "High-Speed Connection"]
  },
  {
    id: 8,
    name: "SME Line 200 Mbps",
    speed: "200 Mbps",
    price: "₹17,698.80",
    validity: "30 Days",
    features: ["Unlimited Data", "24/7 Support", "Enterprise-Grade Connection"]
  }
];
